const resetPassword = {
  resetPasswordTitle: 'Reset your password',
  resetNotSuccess: 'Something went wrong. Please try again, or contact michael@moovex.com',
  resetPasswordBtn: 'Continue',
  resetPasswordHint: 'Please enter a new password.',
  resetSuccessful: 'You have successfully changed your password.',
  backToLogIn: 'Please back to login and sign in again',
  newPassword: 'New Password',
  reEnterPassword: 'Confirm your password',
};

export default resetPassword;
